import React, { useEffect } from 'react'
import { Controller } from 'react-hook-form'
import { DocumentInput } from '../../atoms/DocumentInput/DocumentInput'
import { isValidDocument, getMaskedDocument } from '../../../util/document'
import { PersonalDataTooltip } from '../PersonalDataTooltip'

export const CnpjInput = ({ control, reset, value, clearErrors, type, isLoadingDocument }) => {
  useEffect(() => {
    const isTruthType = type === 'cnpj'

    value &&
      isTruthType &&
      reset({
        cpf: '',
        cnpj: getMaskedDocument(value),
      })
  }, [value])

  return (
    <Controller
      name="cnpj"
      control={control}
      rules={{
        validate: cnpj => isValidDocument(cnpj, 'cnpj'),
      }}
      render={({ field, fieldState }) => (
        <DocumentInput
          {...field}
          {...fieldState}
          documentType="cnpj"
          placeholder="00.000.000/0000-00"
          state={fieldState.isDirty && !!fieldState.error && 'error'}
          stateMessage="Insira um CNPJ válido."
          onFocus={() => clearErrors('cnpj')}
          link={<PersonalDataTooltip />}
          disabled={isLoadingDocument}
        />
      )}
    />
  )
}
